import {
  getCampaign as publicGetCampaign,
  listCampaigns as publicListCampaigns,
  publishCampaign as publicPublishCampaign,
  sendTest as publicSendTest,
  pauseScheduling as publicPauseScheduling,
  reschedule as publicReschedule,
  deleteCampaign as publicDeleteCampaign,
  reuseCampaign as publicReuseCampaign,
  getAudience as publicGetAudience,
  identifySenderAddress as publicIdentifySenderAddress,
  validateLink as publicValidateLink,
  validateHtmlLinks as publicValidateHtmlLinks,
  listStatistics as publicListStatistics,
  listRecipients as publicListRecipients,
} from './email-marketing-v1-campaign-campaigns.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onCampaignDistributedEvent as publicOnCampaignDistributedEvent } from './email-marketing-v1-campaign-campaigns.public.js';
import { onCampaignPausedEvent as publicOnCampaignPausedEvent } from './email-marketing-v1-campaign-campaigns.public.js';
import { onCampaignPublishedEvent as publicOnCampaignPublishedEvent } from './email-marketing-v1-campaign-campaigns.public.js';
import { onCampaignRejectedEvent as publicOnCampaignRejectedEvent } from './email-marketing-v1-campaign-campaigns.public.js';
import { onCampaignScheduledEvent as publicOnCampaignScheduledEvent } from './email-marketing-v1-campaign-campaigns.public.js';
import { onCampaignTerminatedEvent as publicOnCampaignTerminatedEvent } from './email-marketing-v1-campaign-campaigns.public.js';
import { onCampaignCreated as publicOnCampaignCreated } from './email-marketing-v1-campaign-campaigns.public.js';
import { onCampaignDeleted as publicOnCampaignDeleted } from './email-marketing-v1-campaign-campaigns.public.js';
import { onCampaignEmailActivityUpdated as publicOnCampaignEmailActivityUpdated } from './email-marketing-v1-campaign-campaigns.public.js';

export const getCampaign: MaybeContext<
  BuildRESTFunction<typeof publicGetCampaign> & typeof publicGetCampaign
> = /*#__PURE__*/ createRESTModule(publicGetCampaign);
export const listCampaigns: MaybeContext<
  BuildRESTFunction<typeof publicListCampaigns> & typeof publicListCampaigns
> = /*#__PURE__*/ createRESTModule(publicListCampaigns);
export const publishCampaign: MaybeContext<
  BuildRESTFunction<typeof publicPublishCampaign> & typeof publicPublishCampaign
> = /*#__PURE__*/ createRESTModule(publicPublishCampaign);
export const sendTest: MaybeContext<
  BuildRESTFunction<typeof publicSendTest> & typeof publicSendTest
> = /*#__PURE__*/ createRESTModule(publicSendTest);
export const pauseScheduling: MaybeContext<
  BuildRESTFunction<typeof publicPauseScheduling> & typeof publicPauseScheduling
> = /*#__PURE__*/ createRESTModule(publicPauseScheduling);
export const reschedule: MaybeContext<
  BuildRESTFunction<typeof publicReschedule> & typeof publicReschedule
> = /*#__PURE__*/ createRESTModule(publicReschedule);
export const deleteCampaign: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCampaign> & typeof publicDeleteCampaign
> = /*#__PURE__*/ createRESTModule(publicDeleteCampaign);
export const reuseCampaign: MaybeContext<
  BuildRESTFunction<typeof publicReuseCampaign> & typeof publicReuseCampaign
> = /*#__PURE__*/ createRESTModule(publicReuseCampaign);
export const getAudience: MaybeContext<
  BuildRESTFunction<typeof publicGetAudience> & typeof publicGetAudience
> = /*#__PURE__*/ createRESTModule(publicGetAudience);
export const identifySenderAddress: MaybeContext<
  BuildRESTFunction<typeof publicIdentifySenderAddress> &
    typeof publicIdentifySenderAddress
> = /*#__PURE__*/ createRESTModule(publicIdentifySenderAddress);
export const validateLink: MaybeContext<
  BuildRESTFunction<typeof publicValidateLink> & typeof publicValidateLink
> = /*#__PURE__*/ createRESTModule(publicValidateLink);
export const validateHtmlLinks: MaybeContext<
  BuildRESTFunction<typeof publicValidateHtmlLinks> &
    typeof publicValidateHtmlLinks
> = /*#__PURE__*/ createRESTModule(publicValidateHtmlLinks);
export const listStatistics: MaybeContext<
  BuildRESTFunction<typeof publicListStatistics> & typeof publicListStatistics
> = /*#__PURE__*/ createRESTModule(publicListStatistics);
export const listRecipients: MaybeContext<
  BuildRESTFunction<typeof publicListRecipients> & typeof publicListRecipients
> = /*#__PURE__*/ createRESTModule(publicListRecipients);
/**
 * Triggered when a campaign is successfully distributed to all recipients.
 */
export const onCampaignDistributedEvent: BuildEventDefinition<
  typeof publicOnCampaignDistributedEvent
> &
  typeof publicOnCampaignDistributedEvent = createEventModule(
  publicOnCampaignDistributedEvent
);
/**
 * Triggered when a scheduled campaign is paused.
 */
export const onCampaignPausedEvent: BuildEventDefinition<
  typeof publicOnCampaignPausedEvent
> &
  typeof publicOnCampaignPausedEvent = createEventModule(
  publicOnCampaignPausedEvent
);
/**
 * Triggered when a draft campaign is published.
 */
export const onCampaignPublishedEvent: BuildEventDefinition<
  typeof publicOnCampaignPublishedEvent
> &
  typeof publicOnCampaignPublishedEvent = createEventModule(
  publicOnCampaignPublishedEvent
);
/**
 * Triggered when a campaign is identified as abusive and rejected without sending emails to recipients.
 */
export const onCampaignRejectedEvent: BuildEventDefinition<
  typeof publicOnCampaignRejectedEvent
> &
  typeof publicOnCampaignRejectedEvent = createEventModule(
  publicOnCampaignRejectedEvent
);
/**
 * Triggered when a campaign is scheduled to be sent out at the specific time.
 */
export const onCampaignScheduledEvent: BuildEventDefinition<
  typeof publicOnCampaignScheduledEvent
> &
  typeof publicOnCampaignScheduledEvent = createEventModule(
  publicOnCampaignScheduledEvent
);
/**
 * Triggered when the mailing list isn't clean and campaign was terminated.
 */
export const onCampaignTerminatedEvent: BuildEventDefinition<
  typeof publicOnCampaignTerminatedEvent
> &
  typeof publicOnCampaignTerminatedEvent = createEventModule(
  publicOnCampaignTerminatedEvent
);
/**
 * Triggered when a campaign is created.
 */
export const onCampaignCreated: BuildEventDefinition<
  typeof publicOnCampaignCreated
> &
  typeof publicOnCampaignCreated = createEventModule(publicOnCampaignCreated);
/**
 * Triggered when a campaign is deleted.
 */
export const onCampaignDeleted: BuildEventDefinition<
  typeof publicOnCampaignDeleted
> &
  typeof publicOnCampaignDeleted = createEventModule(publicOnCampaignDeleted);
/**
 * Triggered when an email campaign has a new recipient activity.
 */
export const onCampaignEmailActivityUpdated: BuildEventDefinition<
  typeof publicOnCampaignEmailActivityUpdated
> &
  typeof publicOnCampaignEmailActivityUpdated = createEventModule(
  publicOnCampaignEmailActivityUpdated
);

export {
  CampaignEditorTypeEnum,
  CampaignStatusEnum,
  CampaignVisibilityStatusEnum,
  Enum,
  RejectionReasonEnum,
  CampaignSendingStateEnum,
  CampaignTypeEnum,
  ActivityType,
  WebhookIdentityType,
  RecipientsActivityEnum,
} from './email-marketing-v1-campaign-campaigns.universal.js';
export {
  Campaign,
  PublishingData,
  CampaignStatistics,
  LandingPageStatistics,
  DistributionStatistics,
  TotalStatistics,
  RejectionData,
  GetPlaceholderKeysRequest,
  GetPlaceholderKeysResponse,
  GetDefaultComponentsRequest,
  GetDefaultComponentsResponse,
  GetCampaignRequest,
  GetCampaignResponse,
  ListCampaignsRequest,
  Paging,
  CampaignEditorType,
  ListCampaignsResponse,
  CountCampaignsRequest,
  CountCampaignsResponse,
  CreateFromTemplateRequest,
  CreateFromTemplateResponse,
  CreateUserTemplateRequest,
  CreateUserTemplateResponse,
  CreateFromUserTemplateRequest,
  CreateFromUserTemplateResponse,
  PublishCampaignRequest,
  EmailDistributionOptions,
  PublishCampaignResponse,
  Rejected,
  Published,
  Terminated,
  Distributed,
  EmailActivityUpdated,
  EmailActivityUpdatedEventTypeOneOf,
  Click,
  Open,
  SoftBounce,
  HardBounce,
  Scheduled,
  SendTestRequest,
  PlaceholderContent,
  PlaceholderContentValueOneOf,
  PlainText,
  Html,
  Money,
  DateTime,
  Map,
  _Array,
  PlaceholderContentEnum,
  Attachment,
  Integer,
  Decimal,
  LocalDate,
  SendTestResponse,
  PauseSchedulingRequest,
  PauseSchedulingResponse,
  Paused,
  RescheduleRequest,
  RescheduleResponse,
  ArchiveCampaignRequest,
  ArchiveCampaignResponse,
  Archived,
  UnarchiveCampaignRequest,
  UnarchiveCampaignResponse,
  Unarchived,
  UpdateTitleRequest,
  UpdateTitleResponse,
  DeleteCampaignRequest,
  DeleteCampaignResponse,
  ReuseCampaignRequest,
  ReuseCampaignResponse,
  PreviewCampaignRequest,
  PreviewCampaignResponse,
  GetComposerRequest,
  GetComposerResponse,
  Composer,
  DefaultValues,
  UpdateComposerRequest,
  UpdateComposerResponse,
  CreateCampaignRequest,
  CreateCampaignResponse,
  ResendToNonOpenersRequest,
  ResendToNonOpenersResponse,
  GetAudienceRequest,
  GetAudienceResponse,
  CampaignAudience,
  IdentifySenderAddressRequest,
  IdentifySenderAddressResponse,
  CopyUserTemplateToSiteRequest,
  CopyUserTemplateToSiteResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  EstimateFilterSizeRequest,
  EstimateFilterSizeResponse,
  EstimateAudienceSizeRequest,
  EstimateAudienceSizeResponse,
  ReconcileContactRequest,
  ReconcileContactResponse,
  Contact,
  SearchContactsRequest,
  SearchContactsResponse,
  GetLabelsRequest,
  GetLabelsResponse,
  Label,
  SubscribeFromLandingPageRequest,
  SubscribeFromLandingPageResponse,
  ValidateLinkRequest,
  ValidateLinkResponse,
  ValidateHtmlLinksRequest,
  ValidateHtmlLinksResponse,
  GetCampaignMappingRequest,
  GetCampaignMappingResponse,
  UpsertTranslationRequest,
  UpsertTranslationResponse,
  GetUsedPlaceholderKeysRequest,
  GetUsedPlaceholderKeysResponse,
  LookupCampaignMappingRequest,
  LookupCampaignMappingResponse,
  UpsertAutomationTranslatorContentRequest,
  AutomationTranslatorContent,
  UpsertAutomationTranslatorContentResponse,
  GetAutomationTranslatorContentRequest,
  GetAutomationTranslatorContentResponse,
  SendTestBulkRequest,
  SendTestBulkResponse,
  ListStatisticsRequest,
  ListStatisticsResponse,
  CampaignStatisticsContainer,
  ListRecipientsRequest,
  CursorPaging,
  ListRecipientsResponse,
  CampaignRecipientDetails,
  PagingMetadataV2,
  Cursors,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  CampaignDistributedEnvelope,
  CampaignPausedEnvelope,
  CampaignPublishedEnvelope,
  CampaignRejectedEnvelope,
  CampaignScheduledEnvelope,
  CampaignTerminatedEnvelope,
  CampaignCreatedEnvelope,
  CampaignDeletedEnvelope,
  CampaignEmailActivityUpdatedEnvelope,
  GetCampaignOptions,
  ListCampaignsOptions,
  PublishCampaignOptions,
  SendTestOptions,
  ListRecipientsOptions,
} from './email-marketing-v1-campaign-campaigns.universal.js';
export {
  CampaignEditorTypeEnumWithLiterals,
  CampaignStatusEnumWithLiterals,
  CampaignVisibilityStatusEnumWithLiterals,
  EnumWithLiterals,
  RejectionReasonEnumWithLiterals,
  CampaignSendingStateEnumWithLiterals,
  CampaignTypeEnumWithLiterals,
  ActivityTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  RecipientsActivityEnumWithLiterals,
  PublishCampaignApplicationErrors,
} from './email-marketing-v1-campaign-campaigns.universal.js';
